import { AccountSupportType, ServiceType, FiscalInquiryType } from './types';

export const CONSULTATION_TYPES = {
	'account-support': 'Requiero soporte con mi cuenta',
	'service-inquiry': 'Quiero asesoría para contratar un servicio',
	'fiscal-inquiry': 'Requiero asesoría fiscal',
};

export const ACCOUNT_SUPPORT_TYPES: Record<AccountSupportType, string> = {
	'tax-declaration-review': 'Requiero una revisión de mi declaración',
	'payment-line': 'Requiero una nueva línea de captura',
	'missing-declaration': 'No he recibido mi declaración de impuestos',
	'efirma-link': 'No puedo vincular e.firma',
	rfc_link: 'No puedo vincular mi RFC y contraseña',
	csd_link: 'No puedo vincular mi sellos de facturación',
	'payment-issue': 'No puedo realizar un pago',
	'payment-method': 'No puedo modificar mi método de pago',
	'card-charge': 'Necesito ayuda con un cargo hecho a mi tarjeta',
	'info-update': 'No se actualiza mi información correctamente',
	'personal-info': 'Requiero modificar mi información personal',
	'general-inquiry': 'Duda general',
};

export const SERVICE_TYPES: Record<ServiceType, string> = {
	'general-inquiry': 'No lo tengo claro, quiero asesoría para elegir un plan',
	'freelancer-plan': 'Suscripción al Plan Freelancer',
	'past-declarations': 'Regularización de declaraciones atrasadas',
	'platforms-plan': 'Suscripción al Plan Plataformas',
	'annual-declaration': 'Suscripción a la declaración anual',
	'business-plan': 'Suscripción al Plan Empresarial',
};

export const FISCAL_INQUIRY_TYPES: Record<FiscalInquiryType, string> = {
	'income-and-retention': 'Requiero asesoría sobre mis ingresos o retenciones',
	'deductions-inquiry': 'Requiero asesoría sobre deducibilidad',
	'invoicing-inquiries': 'Requiero asesoría sobre facturación',
	'obligations-inquiry': 'Requiero asesoría sobre obligaciones',
	'sat-notifications':
		'Requiero asesoría sobre reportes o correos recibidos del SAT',
};

export const MESSAGE_TEMPLATES: Record<
	AccountSupportType | ServiceType | FiscalInquiryType,
	string
> = {
	'tax-declaration-review': `Hola equipo heru, 

Me pongo en contacto solicitando ayuda con la revisión de mi declaración correspondiente a:

Regímen (ingresa el régimen de la declaración): 
Periodo (ingresa el mes y año de la declaración): 

La revisión que solicito es porque: 

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	'payment-line': `Hola equipo heru, 

Me pongo en contacto solicitando ayuda con una nueva línea de captura para el pago correspondiente a mi declaración:

Regímen (ingresa el régimen de la declaración): 
Periodo (ingresa el mes y año de la declaración): 

Les agradezco que me envién la nueva línea de captura para poder generar el pago.

Gracias.`,

	'card-charge': `Hola equipo heru, 

Me pongo en contacto solicitando ayuda con la aclaración de un pago que se hizo a mi tarjeta. 

La aclaración solicito ya que: 

Les agradezco la atención y quedo al tanto de la información.

Gracias.`,

	'missing-declaration': `Hola equipo heru, 

Me pongo en contacto solicitando ayuda con la revisión de mi declaración correspondiente a:

Regímen (ingresa el régimen de la declaración): 
Periodo (ingresa el mes y año de la declaración): 

Ya que no he recibido los acuses correspondientes de presentación.

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	'info-update': `Hola equipo heru, 

Me pongo en contacto solicitando ayuda con la actualización de mi información fiscal ya que no se ha actualizado correctamente.

La información que requiero se actualice corresponde a: 

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	'payment-method': `Hola equipo heru, 

Me pongo en contacto solicitando ayuda ya que no he logrado actualizar el método de pago en la plataforma para realizar el pago de mis servicios contratados.

- El problema que estoy presentando es:
- Los 4 últimos dígitos de la tarjeta con el problema son:
- La fecha de vencimiento de la tarjeta con el problema es:

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	'payment-issue': `Hola equipo heru, 

Me pongo en contacto solicitando ayuda ya que no he logrado realizar un pago correspondiente a sus servicios.

- El problema que estoy presentando es:
- El método de pago que estoy utilizando es: 
- El total del pago que intenté generar es de: 
- El servicio que estoy intentando contratar es:

(Si tu método de pago es tarjeta agrega el detalle a continuación)
- Los 4 últimos dígitos de la tarjeta con el problema son:
- La fecha de vencimiento de la tarjeta con el problema es:

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	'personal-info': `Hola equipo heru, 

Me pongo en contacto solicitando ayuda, ya que requiero actualizar mi información.

La información anterior:

La información nueva es:

(Para verificar tu identidad) Mi compra más reciente fue:

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	'general-inquiry': `Hola equipo heru, 

Me gustaría recibir asesoría general sobre:

Mis preguntas son:

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	'freelancer-plan': `Hola equipo heru, 

Me gustaría recibir asesoría para la contratación del plan Freelancer.

Especialmente me gustaría que me asesoren respecto:

Mi horario ideal para que se pongan en contacto es:

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	'past-declarations': `Hola equipo heru, 

Me gustaría recibir asesoría para la regularización de declaraciones atrasadas.

Mi situación específica es:

Periodos que necesito regularizar:

Mi horario ideal para que se pongan en contacto es:

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	'platforms-plan': `Hola equipo heru, 

Me gustaría recibir asesoría para la contratación del Plan Plataformas.

Plataformas con las que trabajo:

Especialmente me gustaría que me asesoren respecto:

Mi horario ideal para que se pongan en contacto es:

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	'annual-declaration': `Hola equipo heru, 

Me gustaría recibir asesoría para la suscripción a la declaración anual.

Ejercicio fiscal que necesito declarar:

Especialmente me gustaría que me asesoren respecto:

Mi horario ideal para que se pongan en contacto es:

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	'business-plan': `Hola equipo heru, 

Me gustaría recibir asesoría para la contratación del Plan Empresarial.

Tipo de empresa:
Número de empleados (aproximado):

Especialmente me gustaría que me asesoren respecto:

Mi horario ideal para que se pongan en contacto es:

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	'income-and-retention': `Hola equipo heru, 

Me pongo en contacto solicitando asesoría fiscal sobre mis ingresos o retenciones.

Mi consulta específica es: 

Información relevante para entender mi situación:

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	'deductions-inquiry': `Hola equipo heru, 

Me pongo en contacto solicitando asesoría fiscal sobre deducibilidad.

Mi consulta específica es: 

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	'invoicing-inquiries': `Hola equipo heru, 

Me pongo en contacto solicitando asesoría fiscal sobre facturación.

Mi duda específica es: 

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	'obligations-inquiry': `Hola equipo heru, 

Me pongo en contacto solicitando asesoría fiscal sobre mis obligaciones fiscales.

Mi consulta específica es: 

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	'sat-notifications': `Hola equipo heru, 

Me pongo en contacto solicitando asesoría sobre reportes o correos recibidos del SAT.

El mensaje o reporte que recibí dice:

Fecha de recepción: 
Referencia o folio (si aplica):

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	'efirma-link': `Hola equipo heru, 

Me pongo en contacto solicitando ayuda ya que no puedo vincular mi e.firma en la plataforma.

El problema específico que estoy presentando es:

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	rfc_link: `Hola equipo heru, 

Me pongo en contacto solicitando ayuda ya que no puedo vincular mi RFC y contraseña en la plataforma.

El problema específico que estoy presentando es:

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,

	csd_link: `Hola equipo heru, 

Me pongo en contacto solicitando ayuda ya que no puedo vincular mis sellos de facturación en la plataforma.

El problema específico que estoy presentando es:

Les agradezco la atención y quedo atento a sus comentarios.

Gracias.`,
};
